import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useAuth } from '@/context/auth-context';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';

interface Props {
  menuListItem: {
    name: string;
    onClick?: () => void;
    href?: string;
    icon?: ReactNode;
  }[];
}

export function NavBar({ menuListItem }: Props) {
  const { user } = useAuth();

  return (
    <nav className="bg-white shadow-sm">
      <div className="mx-auto px-4 sm:px-16">
        <div className="flex h-16 justify-between">
          <div className="flex"></div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            {/* Profile dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  type="button"
                  className="relative flex items-center gap-3 rounded-full bg-white text-sm cursor-pointer focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
                >
                  <div className="text-right">
                    <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                    <p className="text-xs text-gray-500">{user?.email}</p>
                  </div>
                  <Avatar className="size-8">
                    <AvatarImage src={user?.avatar} alt="User avatar" />
                    <AvatarFallback>{user?.name}</AvatarFallback>
                  </Avatar>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                {menuListItem.map((item) => (
                  <DropdownMenuItem key={item.name} onClick={item.onClick} asChild={!!item.href}>
                    {item.href ? (
                      <Link to={item.href} className="flex items-center gap-3 w-full">
                        {item.icon}
                        {item.name}
                      </Link>
                    ) : (
                      <span className="flex items-center gap-3 w-full cursor-pointer">
                        {item.icon}
                        {item.name}
                      </span>
                    )}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
